<template>
  <el-container>
    <el-main style="padding:0;width:100vh">
      <vm-table
          ref="vmTable"
          height="74vh"
          :filter.sync="filter"
          module="basic"
          url="emEquipmentRates">
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="统计日期">
              <el-input v-model.trim="filter.statisticsDate" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column prop="statisticsDate" align="center" label="统计日期"/>
        <el-table-column prop="faultTime" align="center" label="故障时间（min）"/>
        <el-table-column prop="type" align="center" label="统计类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type===7" style="color: #2D8CF0">
              周
            </span>
            <span v-else-if="scope.row.type===30" style="color: red">
              月
            </span>
            <span v-else>
              日
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="rate" align="center" label="完好率"/>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="180px">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.isArchive" type="primary" @click="saveArchive(scope.row.pkid)">存档</el-button>
            <!--          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </vm-table>
    </el-main>
  </el-container>
</template>


<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "EMEquipmentRatesList",
    components: {VmTable, VmSearch},
    data() {
      return {
        importLoading: false,
        disabled: false,
        ids: [],
        filter: {
          statisticsDate: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      saveArchive(id) {
        this.$confirm("确定存档吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .get("basic",`emEquipmentRates/saveArchive/${id}`).then(() => {
              this.getList(-1);
              this.$message.success("存档成功");
            });
        });
      },
    },
  };
</script>

<style scoped>
</style>
